import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DatasetVersionService } from '../analytics/dataset-version.service';
import { TenantContextService } from '../tenant/tenant-context.service';
import { environment } from '../../../environments/environment';

const apiBase = environment.api.replace(/\/+$/, '');

function isApiRequest(url: string): boolean {
  return url === apiBase || url.startsWith(apiBase + '/');
}

/**
 * Feeds `X-Analytics-Dataset-Version` from API responses into
 * {@link DatasetVersionService} (GF-4823).
 *
 * The tenant is passed alongside so a tenant switch resets the tracked pair.
 */
export const datasetVersionInterceptor: HttpInterceptorFn = (
  req,
  next
): Observable<HttpEvent<unknown>> => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }
  const datasetVersion = inject(DatasetVersionService);
  const tenantContext = inject(TenantContextService);
  const requestedTenant = tenantContext.currentTenantKey().trim() || null;
  return next(req).pipe(
    tap((event) => {
      if (!(event instanceof HttpResponse)) {
        return;
      }
      // Drop a straggler from a tenant the user has since switched away from.
      // Recording it would reset the tracked pair back to the old tenant and
      // re-adopt its version while a different tenant is on screen.
      if ((tenantContext.currentTenantKey().trim() || null) !== requestedTenant) {
        return;
      }
      datasetVersion.record(event.headers.get('X-Analytics-Dataset-Version'), requestedTenant);
    })
  );
};
